import PropTypes from "prop-types";
import classNames from "classnames";
import { useState } from "react";
import SinglePageAppLink from "../../../../components/SinglePageAppLink";
import styles from "./GuidedSearchBoardTile.css";

const getTileImageUrls = (imageUrl, imageUrls) => {
  const validImageUrls = (imageUrls || []).filter(Boolean);

  if (validImageUrls.length >= 4) {
    return validImageUrls.slice(0, 4);
  }

  const fallbackImageUrl = validImageUrls[0] || imageUrl;

  if (!fallbackImageUrl) {
    return [];
  }

  return Array.from(
    { length: 4 },
    (_, index) => validImageUrls[index] || fallbackImageUrl,
  );
};

export const GuidedSearchBoardTile = ({
  selectionKey,
  name,
  imageUrl,
  imageUrls,
  linkUrl,
  isSelected,
  onSelect,
}) => {
  const [imageErrors, setImageErrors] = useState({});
  const tileImageUrls = getTileImageUrls(imageUrl, imageUrls);

  const handleImageError = (index) => {
    setImageErrors((currentErrors) => ({
      ...currentErrors,
      [index]: true,
    }));
  };

  return (
    <li
      className={styles.tile}
      data-guided-search-selected={isSelected ? "true" : "false"}
    >
      <SinglePageAppLink
        href={linkUrl}
        className={styles.link}
        onClick={() => onSelect(selectionKey)}
      >
        <div
          className={styles.imageWrapper}
          data-testid="guided-search-board-image-wrapper"
        >
          {tileImageUrls.map((tileImageUrl, imageIndex) =>
            imageErrors[imageIndex] ? null : (
              <img
                key={`${selectionKey}-${imageIndex}-${tileImageUrl}`}
                src={tileImageUrl}
                alt={`${name} ${imageIndex + 1}`}
                className={styles.image}
                loading="lazy"
                onError={() => handleImageError(imageIndex)}
              />
            ),
          )}
        </div>
        <p
          className={classNames(styles.name, {
            [styles.nameSelected]: isSelected,
          })}
        >
          {name}
        </p>
      </SinglePageAppLink>
    </li>
  );
};

GuidedSearchBoardTile.propTypes = {
  selectionKey: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  name: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  imageUrls: PropTypes.arrayOf(PropTypes.string),
  linkUrl: PropTypes.string.isRequired,
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
};

export default GuidedSearchBoardTile;
